import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=aa16bc02&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=aa16bc02&lang=scss&scoped=true&"
import style1 from "./UploadImg.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa16bc02",
  null
  
)

export default component.exports